export default "__VITE_ASSET__CGjuKrjL__"